<template>
  <div class="rk-chart-num">
    <div v-for="(element, index) in data" :key="index" class="rk-num-detail">
      <div class=" chart-font " :class="getApdexClass(element.avgNum)">
        {{
          typeof element.avgNum === 'string'
            ? element.avgNum
            : isNaN(element.avgNum)
            ? null
            : element.avgNum.toFixed(2)
        }}
        {{ item.unit ? item.unit : '' }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChartNum',
  props: {
    data: {},
    item: {}
  },
  methods: {
    getApdexClass(val) {
      if (this.item.colorEncoder) {
        if (val > 0.84) {
          return 'good';
        } else if (val > 0.68 && val < 0.84) {
          return 'fair';
        } else {
          return 'poor';
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.rk-chart-num {
  font-size: 14px;
  color: $font-primary;
  margin-bottom: 50px;
  height: 100%;
}
.rk-num-detail {
  height: 100%;

  //   span:first-child {
  //     padding-right: 8px;
  //     box-sizing: border-box;
  //     color: $font-primary;
  //   }
}
.chart-font {
  font-size: 20px;
  line-height: 25px;
  margin-top: 30px;
  height: 100%;
  margin-left: 15px;
  text-align: left;
}
.good {
  color: $good;
}
.fair {
  color: $fair;
}
.poor {
  color: $poor;
}
</style>
